import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIsFramed } from 'site-modules/shared/hooks/use-is-framed';
import { AiLinkContent } from 'site-modules/shared/components/ai-link/ai-link-content';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PageModel } from 'client/data/models/page';
import { buildAiAssistantUrl } from 'site-modules/shared/utils/ai-assistant-url';
import { GlobalNavLink } from './global-nav-link';

const AiNavigationLinkUI = memo(({ location, use2027Theme = false }) => {
  const canvasUrl = buildAiAssistantUrl(location);
  const isFramed = useIsFramed();
  const aiLinkConfig = useMemo(
    () =>
      isFramed
        ? {
            attributes: {
              tag: 'span',
            },
          }
        : {
            trackingId: 'open_chat_canvas',
            'data-tracking-ignore-value': true,
            url: canvasUrl,
            attributes: {
              rel: 'nofollow',
            },
          },
    [canvasUrl, isFramed]
  );

  return (
    <GlobalNavLink
      link={aiLinkConfig}
      pathname={location.pathname}
      globalNavLinkClasses={use2027Theme ? 'global-nav-link' : undefined}
    >
      <span className="d-inline-flex justify-content-center align-items-center">
        <AiLinkContent newLabelClasses="with-bg-dark text-white ms-0" withSparkle use2027Theme={use2027Theme} />
      </span>
      <div
        className={classnames('mt-0_25 size-14', {
          'text-white': !use2027Theme,
          'text-cool-gray-10': use2027Theme,
        })}
      >
        Ask anything from reviews to pricing to deals.
      </div>
    </GlobalNavLink>
  );
});

AiNavigationLinkUI.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  use2027Theme: PropTypes.bool,
};

AiNavigationLinkUI.displayName = 'AiNavigationLinkUI';

export const AiNavigationLink = connectToModel(AiNavigationLinkUI, {
  location: bindToPath('location', PageModel, null, false),
});
